import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type", "disabled", "data-testid"]
const _hoisted_2 = { class: "position-relative flex-center w-100" }
const _hoisted_3 = {
  key: 0,
  class: "position-absolute flex-center",
  style: {"inset":"0"}
}
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "visually-hidden" }

import { computed } from 'vue';

export type ButtonVariant = typeof VARIANTS[number];
export type ButtonSize = typeof SIZES[number];
export type ButtonRounded = typeof ROUNDED[number];

interface ButtonProps {
  loading?: boolean;
  disabled?: boolean;
  loadingMsg?: string;
  type?: "button" | "submit" | "reset";
  testId?: string;
  variant?: ButtonVariant;
  size?: ButtonSize;
  rounded?: ButtonRounded;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loadingMsg: { default: "Loading..." },
    type: { default: "button" },
    testId: { default: "button" },
    variant: { default: "default" },
    size: { default: "default" },
    rounded: { default: "default" }
  },
  setup(__props: any) {

const VARIANTS = [
  "default",
  "link",
  "naked",
  "invert",
  "add",
  "create",
  "delete",
  "edit",
  "view",
  "outline",
  "deactivate",
  "warning",
  "danger",
  "stale",
  "cancel"
] as const;
const SIZES = ["xs", "sm", "default", "lg", "xl", "xxl", "full"] as const;
const ROUNDED = ["xs", "sm", "default", "lg", "xl", "xxl", "full"] as const;

const variantMap: Record<ButtonVariant, string[]> = {
  default: ['button'],
  link: ['naked', 'link'],
  naked: ['naked'],
  invert: ['invert'],
  add: ['add'],
  create: ['create'],
  delete: ['delete'],
  edit: ['edit'],
  view: ['view'],
  outline: ['outline'],
  deactivate: ['deactivate'],
  warning: ['warning'],
  danger: ['danger'],
  stale: ['stale'],
  cancel: ['cancel'],
};

const sizeMap: Record<ButtonSize, string> = {
  xs: "xtra-small",
  sm: "small",
  default: "",
  lg: "large",
  xl: "xtra-large",
  xxl: "xxtra-large",
  full: ""
};

const roundedMap: Record<ButtonRounded, string> = {
  xs: "rounded-xs",
  sm: "rounded-sm",
  default: "",
  lg: "rounded-lg",
  xl: "rounded-xl",
  xxl: "rounded-xxl",
  full: "rounded-full"
};

const props = __props;

const buttonClasses = computed(() => {
  const classes: string[] = [];

  // Add variant classes from the map
  classes.push(...variantMap[props.variant]);

  // Add size class
  const sizeClass = sizeMap[props.size];
  if (sizeClass) {
    classes.push(sizeClass);
  }

  // Add rounded class
  const roundedClass = roundedMap[props.rounded];
  if (roundedClass) {
    classes.push(roundedClass);
  }

  return classes.filter(Boolean).join(' ');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    class: _normalizeClass([buttonClasses.value, { disabled: __props.loading || __props.disabled }]),
    disabled: __props.disabled || __props.loading,
    "data-testid": __props.testId
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "flex-center w-100",
        style: _normalizeStyle({ visibility: __props.loading ? 'hidden' : 'visible' })
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 4),
      (__props.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _createElementVNode("output", {
              class: "spinner-border spinner-border-sm",
              "aria-label": __props.loadingMsg
            }, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(__props.loadingMsg), 1)
            ], 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 10, _hoisted_1))
}
}

})